export const messages = {
  en: {
    ownerApplyInvoice: {
      title: 'Invoicing',
      back: 'Back',
      room: 'Room',
      roomPlaceholder: 'Please select room',
      chooseRoom: 'Choose Room',
      owner: 'Owner',
      ownerNamePlaceholder: 'Owner name',
      noOwner: 'No owner found under this room',
      ownerNoPhone: 'Owner has no phone, cannot get invoice heading. Please contact owner to complete.',
      chooseOwner: 'Please select owner',
      invoiceTitle: 'Invoice Title',
      invoiceTitlePlaceholder: 'Please enter invoice title',
      invoiceTitleRequired: 'Invoice title is required',
      taxpayerId: 'Taxpayer ID',
      taxpayerIdPlaceholder: 'Please enter taxpayer ID',
      invoiceKind: 'Invoice Kind',
      invoiceKindPlaceholder: 'Please select invoice kind',
      invoiceKindRequired: 'Invoice kind is required',
      normalInvoice: 'Normal Invoice',
      specialInvoice: 'Special VAT Invoice',
      taxNoRequired: 'Taxpayer ID is required for special VAT invoice',
      bankAccountRequired: 'Bank account is required for special VAT invoice',
      invoiceType: 'Invoice Type',
      invoiceTypePlaceholder: 'Please select invoice type',
      invoiceTypeRequired: 'Invoice type is required',
      contactPhone: 'Contact Phone',
      contactPhonePlaceholder: 'Owner phone',
      addressPhone: 'Address',
      addressPlaceholder: 'Please enter address',
      email: 'Email',
      emailPlaceholder: 'Please enter email (optional)',
      bankAccount: 'Bank Account',
      bankAccountPlaceholder: 'Please enter bank account',
      remark: 'Remark',
      remarkPlaceholder: 'Remark (optional)',
      personal: 'Personal',
      enterprise: 'Enterprise',
      chooseExistingHeading: 'Choose Existing Heading',
      paidFees: 'Uninvoiced Paid Fees',
      feeName: 'Fee Item',
      payer: 'Payer',
      receivablePaid: 'Receivable/Paid',
      paymentMethod: 'Payment Method',
      paymentPeriod: 'Payment Period',
      paymentTime: 'Payment Time',
      cashier: 'Cashier',
      status: 'Status',
      noFeeSelected: 'Please select one paid fee record',
      submit: 'Submit'
    },
    searchOwnerInvoice: {
      title: 'Select Invoice Heading',
      invoiceType: 'Invoice Type',
      invoiceTitle: 'Invoice Title',
      taxpayerId: 'Taxpayer ID',
      addressPhone: 'Address',
      operation: 'Operation',
      search: 'Search',
      placeholderOwner: 'Enter heading name',
      placeholderUserPhone: 'Enter owner phone',
      userPhoneRequired: 'Please enter owner phone',
      select: 'Select',
      personal: 'Personal',
      company: 'Company'
    }
  },
  zh: {
    ownerApplyInvoice: {
      title: '开票',
      back: '返回',
      room: '房屋',
      roomPlaceholder: '请选择房屋',
      chooseRoom: '选择房屋',
      owner: '业主',
      ownerNamePlaceholder: '业主姓名',
      noOwner: '该房屋下未查询到业主',
      ownerNoPhone: '业主无手机号，无法获取抬头，请联系业主完善',
      chooseOwner: '请选择业主',
      invoiceTitle: '发票抬头',
      invoiceTitlePlaceholder: '请填写发票名头',
      invoiceTitleRequired: '发票名头不能为空',
      taxpayerId: '纳税人识别号',
      taxpayerIdPlaceholder: '请填写纳税人识别号',
      invoiceKind: '发票种类',
      invoiceKindPlaceholder: '请选择发票种类',
      invoiceKindRequired: '发票种类不能为空',
      normalInvoice: '普票',
      specialInvoice: '专票',
      taxNoRequired: '专票必须填写纳税人识别号',
      bankAccountRequired: '专票必须填写开户行及账号',
      invoiceType: '抬头类型',
      invoiceTypePlaceholder: '请选择抬头类型',
      invoiceTypeRequired: '抬头类型不能为空',
      contactPhone: '联系电话',
      contactPhonePlaceholder: '业主手机号',
      addressPhone: '地址',
      addressPlaceholder: '请填写地址',
      email: '邮箱',
      emailPlaceholder: '请填写邮箱(选填)',
      bankAccount: '开户行及账号',
      bankAccountPlaceholder: '请填写开户行及账号',
      remark: '备注',
      remarkPlaceholder: '选填备注',
      personal: '个人',
      enterprise: '企业',
      chooseExistingHeading: '选择已有抬头',
      paidFees: '未开票缴费记录',
      feeName: '费用项',
      payer: '收费对象',
      receivablePaid: '应收/实收',
      paymentMethod: '缴费方式',
      paymentPeriod: '缴费起始段',
      paymentTime: '缴费时间',
      cashier: '收银员',
      status: '状态',
      noFeeSelected: '请选择一条缴费记录',
      submit: '提交'
    },
    searchOwnerInvoice: {
      title: '选择发票抬头',
      invoiceType: '发票类型',
      invoiceTitle: '发票名头',
      taxpayerId: '纳税人识别号',
      addressPhone: '地址',
      operation: '操作',
      search: '查询',
      placeholderOwner: '输入抬头名称',
      placeholderUserPhone: '输入业主手机号',
      userPhoneRequired: '请先输入业主手机号',
      select: '选择',
      personal: '个人',
      company: '公司'
    }
  },
  'zh-TW': {
    ownerApplyInvoice: {
      title: '開票',
      back: '返回',
      room: '房屋',
      roomPlaceholder: '請選擇房屋',
      chooseRoom: '選擇房屋',
      owner: '業主',
      ownerNamePlaceholder: '業主姓名',
      noOwner: '該房屋下未查詢到業主',
      ownerNoPhone: '業主無手機號，無法獲取抬頭，請聯繫業主完善',
      chooseOwner: '請選擇業主',
      invoiceTitle: '發票抬頭',
      invoiceTitlePlaceholder: '請填寫發票名頭',
      invoiceTitleRequired: '發票名頭不能為空',
      taxpayerId: '納稅人識別號',
      taxpayerIdPlaceholder: '請填寫納稅人識別號',
      invoiceKind: '發票種類',
      invoiceKindPlaceholder: '請選擇發票種類',
      invoiceKindRequired: '發票種類不能為空',
      normalInvoice: '普票',
      specialInvoice: '專票',
      taxNoRequired: '專票必須填寫納稅人識別號',
      bankAccountRequired: '專票必須填寫開戶行及帳號',
      invoiceType: '抬頭類型',
      invoiceTypePlaceholder: '請選擇抬頭類型',
      invoiceTypeRequired: '抬頭類型不能為空',
      contactPhone: '聯繫電話',
      contactPhonePlaceholder: '業主手機號',
      addressPhone: '地址',
      addressPlaceholder: '請填寫地址',
      email: '郵箱',
      emailPlaceholder: '請填寫郵箱(選填)',
      bankAccount: '開戶行及帳號',
      bankAccountPlaceholder: '請填寫開戶行及帳號',
      remark: '備註',
      remarkPlaceholder: '選填備註',
      personal: '個人',
      enterprise: '企業',
      chooseExistingHeading: '選擇已有抬頭',
      paidFees: '未開票繳費記錄',
      feeName: '費用項',
      payer: '收費對象',
      receivablePaid: '應收/實收',
      paymentMethod: '繳費方式',
      paymentPeriod: '繳費起始段',
      paymentTime: '繳費時間',
      cashier: '收銀員',
      status: '狀態',
      noFeeSelected: '請選擇一條繳費記錄',
      submit: '提交'
    },
    searchOwnerInvoice: {
      title: '選擇發票抬頭',
      invoiceType: '發票類型',
      invoiceTitle: '發票名頭',
      taxpayerId: '納稅人識別號',
      addressPhone: '地址',
      operation: '操作',
      search: '查詢',
      placeholderOwner: '輸入抬頭名稱',
      placeholderUserPhone: '輸入業主手機號',
      userPhoneRequired: '請先輸入業主手機號',
      select: '選擇',
      personal: '個人',
      company: '公司'
    }
  }
}
